'use strict';

var $ = require('jquery');
var ViewportTracker = require('../lib/ViewportTracker.ts').default;

function Accordion(config) {
	this.config = $.extend({}, {
		scope: 'body'
	}, config);
}

Accordion.prototype.activate = function () {
	this.attachHandlers('filterTrigger-mobile');
	this.attachHandlers('filterTrigger-desktopOnly');
	this.escapeAccordion('filterTrigger-mobile');
	this.escapeAccordion('filterTrigger-desktopOnly');
};

Accordion.prototype.attachHandlers = function (item) {
	var that = this;

	$(document).on('click', '.' + item, function(event) {
		event.preventDefault();

		var accordionElement = $(this).closest('.' + item);
		that.toggleAccordion(item, accordionElement);
	});
};

Accordion.prototype.toggleAccordion = function (item, accordion) {
	if ($(accordion).hasClass(item + '--active')) {
		$(accordion).removeClass(item + '--active');
	} else {
		// collapse all
		$('.filterTrigger-mobile').removeClass(item + '--active');
		$('.filterTrigger-desktopOnly').removeClass(item + '--active');

		$(accordion).addClass(item + '--active');
	}
};

Accordion.prototype.escapeAccordion = function (item) {
	var closeAccordion = function() {
		var toClose = $('.' + item + '--active');
		if (toClose.length === 0) {
			return false;
		}
		toClose.removeClass(item + '--active');
		return true;
	};
	$(window).on('click touchstart', function(event) {
		if ((event.target).closest('.filterTrigger-desktopOnly--active') || (event.target).closest('.filterTrigger-mobile--active') || (event.target).closest('.filterPanel')) {
			return;
		}
		closeAccordion();
	});
	$(document).on('keyup', function(e) {
		if (e.key === "Escape") { // escape key maps to keycode `27`
			if (!closeAccordion() && location.hash === '#filtersForm') {
				document.querySelector('.filtersCloseButton-mobileOnly').click();
			}
		}
	});
};

module.exports = Accordion;

